import { useTranslation } from "react-i18next";
import { ToastProps } from "../ToastManager";

export type NoticeToastProps = {
  i18nKey: string
  variant?: "success" | "info" | "warning" | "danger"
  icon?: string
  reference?: string
} & ToastProps

export function NoticeToast({ i18nKey, variant = "info", icon, reference, dismiss }: NoticeToastProps) {
  const { t } = useTranslation();

  return (
    <div className={`notification is-${variant}`} onClick={dismiss} style={{ cursor: "pointer" }}>
      {icon && (
        <span className="icon mr-2">
          <i className={icon} aria-hidden="true" />
        </span>
      )}
      <span>{t(i18nKey)}</span>
      {reference && (
        <div className="is-size-7 mt-1" style={{ opacity: 0.7, fontFamily: "monospace" }}>
          {t("toast.reference", { id: reference })}
        </div>
      )}
    </div>
  );
}
